import {
  type GetSearchLinkResultsArgs,
  useInfiniteScroll,
  useLazyGetTourSearchLinksResultsQuery,
} from '@carboncopyco/data';
import type { DropdownFilterItemContent } from '@carboncopyco/ui';
import { useEffect, useMemo, useState } from 'react';
import { SessionsBreakdownFilter } from '../../../Controls/SessionsBreakdownFilter';
import { useTourPageProps } from '../../TourPageContext';

export const TourLinksFilter = () => {
  const { tourId, organizationId, workspaceId } = useTourPageProps();
  const [query, setQuery] = useState('');

  const fetchArgs = useMemo<GetSearchLinkResultsArgs>(
    () => ({
      workspaces: [workspaceId],
      organizationId,
      id: String(tourId),
      query,
    }),
    [organizationId, tourId, query, workspaceId]
  );

  const {
    items,
    isLoading,
    isLoadingBatch,
    fetchFirstBatch,
    fetchNextBatch,
    isEmpty,
  } = useInfiniteScroll(useLazyGetTourSearchLinksResultsQuery);

  useEffect(() => {
    fetchFirstBatch(fetchArgs);
  }, [fetchArgs, fetchFirstBatch]);

  const options: DropdownFilterItemContent<string>[] =
    items?.map((item) => ({
      ...item,
      id: String(item.id),
      label: item.options.linkDescription,
    })) ?? [];

  return (
    <SessionsBreakdownFilter
      type="links"
      placeholder="Link Name"
      options={options}
      query={query}
      setQuery={setQuery}
      onInputChange={() => {
        fetchFirstBatch(fetchArgs);
      }}
      fetchNextBatch={() => {
        fetchNextBatch(fetchArgs);
      }}
      isLoading={isLoading}
      isLoadingBatch={isLoadingBatch}
      disabled={isEmpty}
    />
  );
};
